<template>
  <div class="dashboardGrid">
    <div class="halfWithCard">
      <div class="cardSubTitle">De sista 5 TWEETS</div>
      <div class="tableWrapper">
        <el-timeline>
          <el-timeline-item timestamp="2019-11-15" placement="top">
            <el-card>
              <div>
                <img src="../assets/images/twitter-tweet-1.jpeg" class="timelineImage" />
              </div>
              <div>
                <div class="timelineCardTitle">Oavsett vem man är ska man bli väl bemött...</div>
                <div class="timelineCardContent">
                  <span>
                    <img src="../assets/images/icon-comment.png" alt />4
                  </span>
                  <span>
                    <img src="../assets/images/icon-retweet.png" alt />18
                  </span>
                  <span>
                    <img src="../assets/images/icon-heart.png" alt />1
                  </span>
                  <span>
                    <img src="../assets/images/icon-open.png" alt />
                  </span>
                </div>
              </div>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2019-11-10" placement="top">
            <el-card>
              <div>
                <img src="../assets/images/twitter-tweet-2.jpeg" class="timelineImage" />
              </div>
              <div>
                <div class="timelineCardTitle">Idag är det #världsdiabetesdagen Vi passar...</div>
                <div class="timelineCardContent">
                  <span>
                    <img src="../assets/images/icon-comment.png" alt />3
                  </span>
                  <span>
                    <img src="../assets/images/icon-retweet.png" alt />10
                  </span>
                  <span>
                    <img src="../assets/images/icon-heart.png" alt />10
                  </span>
                  <span>
                    <img src="../assets/images/icon-open.png" alt />
                  </span>
                </div>
              </div>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2019-11-05" placement="top">
            <el-card>
              <div>
                <img src="../assets/images/twitter-tweet-3.jpeg" class="timelineImage" />
              </div>
              <div>
                <div
                  class="timelineCardTitle"
                >Hur arbetar Försäkringskassan, Jämställdhetsmyndigheten...</div>
                <div class="timelineCardContent">
                  <span>
                    <img src="../assets/images/icon-comment.png" alt />2
                  </span>
                  <span>
                    <img src="../assets/images/icon-retweet.png" alt />7
                  </span>
                  <span>
                    <img src="../assets/images/icon-heart.png" alt />3
                  </span>
                  <span>
                    <img src="../assets/images/icon-open.png" alt />
                  </span>
                </div>
              </div>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2019-11-01" placement="top">
            <el-card>
              <div>
                <img src="../assets/images/twitter-tweet-4.jpeg" class="timelineImage" />
              </div>
              <div>
                <div
                  class="timelineCardTitle"
                >Bra diskussion idag! #Försäkringskassan bjöd in till...</div>
                <div class="timelineCardContent">
                  <span>
                    <img src="../assets/images/icon-comment.png" alt />3
                  </span>
                  <span>
                    <img src="../assets/images/icon-retweet.png" alt />14
                  </span>
                  <span>
                    <img src="../assets/images/icon-heart.png" alt />1
                  </span>
                  <span>
                    <img src="../assets/images/icon-open.png" alt />
                  </span>
                </div>
              </div>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2019-10-15" placement="top">
            <el-card>
              <div>
                <img src="../assets/images/twitter-tweet-5.jpeg" class="timelineImage" />
              </div>
              <div>
                <div class="timelineCardTitle">Ska du till @MRdagarna i Linköping? Missa inte...</div>
                <div class="timelineCardContent">
                  <span>
                    <img src="../assets/images/icon-comment.png" alt />1
                  </span>
                  <span>
                    <img src="../assets/images/icon-retweet.png" alt />1
                  </span>
                  <span>
                    <img src="../assets/images/icon-heart.png" alt />1
                  </span>
                  <span>
                    <img src="../assets/images/icon-open.png" alt />
                  </span>
                </div>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
        <div class="cardBottomContainer">
          <a href="#" alt class="cardBottomLink channelColorFacebookText">Visa Mer Tweets</a>
        </div>
      </div>
    </div>
    <div class="halfWithCard" style="height: 530px;">
      <div class="cardSubTitle">Tweetaktivitet under de sista åren</div>
      <div id="chart-bar"></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    // ...
  },

  async mounted () {
    var options = {
      chart: {
        height: 500,
        type: 'bar',
        stacked: true,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: true
        }
      },
      stroke: {
        width: 1,
        colors: ['#fff']
      },
      series: [
        {
          name: 'Messages',
          data: [44, 55, 41, 37, 22, 43, 21, 37, 22, 43, 21]
        },
        {
          name: 'Retweets',
          data: [53, 32, 33, 52, 13, 43, 32, 77, 22, 43, 21]
        },
        {
          name: 'Likes',
          data: [12, 17, 11, 9, 15, 11, 20, 32, 33, 52, 13]
        }
      ],
      xaxis: {
        categories: [2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019],
        labels: {
          formatter: function (val) {
            return val + 'K';
          }
        }
      },
      yaxis: {
        title: {
          text: undefined
        }
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + 'K';
          }
        }
      },
      fill: {
        opacity: 1
      }
    };

    var chart = new ApexCharts(document.querySelector('#chart-bar'), options);

    chart.render();
  }
};
</script>
